import { gql } from "gql";

export const DELETE_COMPANY_DOCUMENT_FOLDER = gql(/* GraphQL */ `
  mutation DeleteCompanyDocumentFolder($id: ID!) {
    deleteCompanyDocumentFolder(id: $id)
  }
`);
